//Angular
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//App Components
import { BarChartComponent } from './ngx-echarts/bar-chart/bar-chart.component';
import { ChargeLoyaltyRulesComponent } from './forms/charge-rules/loyalty-rules/charge-loyalty-rules.component';
import { ChargePrepaidRulesComponent } from './forms/charge-rules/prepaid-rules/charge-prepaid-rules.component';
import { CreditCardSimpleComponent } from './card/credit-card-simple/credit-card-simple.component';
import { DialogAccountSettingsComponent } from './dialog/account-settings/account-settings.component';
import { DialogCustomerAddressbookComponent } from './dialog/customer-addressbook/customer-addressbook.component';
import { DialogCustomerPaymentsComponent} from './dialog/customer-payments/customer-payments.component';
import { DialogCustomerShippingMethodComponent} from './dialog/customer-shippingMethod/customer-shippingmethod.component';
import { DialogLinkRateplanChargeComponent } from './link-rateplan-charge/link-rateplan-charge.component';
import { DialogLinkSubscriptionComponent } from './link-subscription/link-subscription.component';
import { DialogManageFiltersComponent } from './dialog/manage-filters/manage-filters.component';
import { DialogNewChargeComponent } from './dialog/new-charge/dialog-new-charge.component';
import { DialogShortcutsComponent } from './dialog/shortcuts/shotrcuts.component';
import { BannerTestComponent } from './banner-test/banner-test.component';
import { FormChargeDetailsComponent } from '../_shared/forms/charge-details/charge-details.component';
import { FormChargePriceComponent } from '../_shared/forms/charge-price/charge-price.component';
import { FormChargeScheduleComponent } from '../_shared/forms/charge-schedule/charge-schedule.component';
import { FormChargeRulesComponent } from './forms/charge-rules/charge-rules.component';
import { FormChargeCutOffRulesComponent } from './forms/charge-rules/cutoff-rules/charge-cutoff-rules.component';
import { HorizontalBarChartComponent } from './ngx-echarts/horizontal-bar-chart/horizontal-bar-chart.component';
import { HeaderComponent } from './components/header/header.component';
import { GridComponent } from './grid/grid.component';
import { LineChartComponent } from './ngx-echarts/line-chart/line-chart.component';
import { NavSideComponent } from './nav-side/nav-side.component';
import { PanelAccountComponent } from './panel-account/panel-account.component';
import { PanelFiltersComponent } from './panel-filters/panel-filters.component';
import { PanelFrequencyComponent } from './panel-frequency/panel-frequency.component';
import { PanelGridSearchComponent } from './panel-grid-search/panel-grid-search.component';
import { PanelPreferencesComponent } from './panel-preferences/panel-preferences.component';
import { PanelProductPriceComponent } from './panel-product-price/product-price.component';

import { SystemMessageComponent } from './system-message/system-message.component';
import { ExportNotificationComponent } from "./export-notifications/export-notification.component";
import {DialogSyncActivePlansComponent} from "./dialog/sync-active-plans/dialog-sync-active-plans.component";

//App Directives
import { ClickOutsideDirective } from './directives/on-click-outside.directive';
//App Modules
import { AppMaterialModule } from '../../../app.material';
import { AppSharedModule } from 'src/app/_shared/app.shared.module';
import { MainRoutingModule } from '../main.routing';
// libraries
import { NgxEchartsModule } from 'ngx-echarts';
import { MainService } from './_services/api/main.service';
import { NgxCleaveDirectiveModule } from 'ngx-cleave-directive';

import { RebNgxMatMenuModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-menu';
import { RebNgxMatMenuItemModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-menu-item';
import { RebNgxMatMenuButtonItemModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-menu-button-item';
import { RebNgxMatButtonModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-button';
import { RebNgxMatTabsModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-tabs';
import { RebNgxMatTabItemModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-tab-item';
import { RebNgxNavbarModule } from '@rhinosaas/reb-ngx/reb-ngx-navbar';
import { GlobalHeaderComponent } from './components/global-header/global-header.component';
import { GlobalHeaderImplComponent } from './global-header-impl/global-header-impl.component';
import { NavbarComponent } from './navbar/navbar.component';
import { RebNgxChipModule } from '@rhinosaas/reb-ngx';
import { StatusChipComponent } from './status-chip/status-chip.component';
import { RebNgxMatButtonIconModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-button-icon';
import { RebNgxAvatarModule } from '@rhinosaas/reb-ngx/reb-ngx-avatar';
import { RebNgxMatMenuIconModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-menu-icon';
import { RebNgxLabelModule } from '@rhinosaas/reb-ngx/reb-ngx-label';
import { RebNgxDividerModule } from '@rhinosaas/reb-ngx/reb-ngx-divider';
import { RebNgxHeadingLabelModule } from '@rhinosaas/reb-ngx/reb-ngx-heading-label';
import { RebNgxIconModule } from '@rhinosaas/reb-ngx/reb-ngx-icon';
import { UsageBasedRulesComponent } from './forms/charge-rules/usage-based-rules/usage-based-rules.component';
import {  RestrictionPipe } from 'src/app/_shared/services/permission/restriction.pipe';
import { RestrictionDirective } from 'src/app/_shared/services/permission/restriction.directive';
import { OfflineCardSimpleComponent } from './card/offline-card-simple/offline-card-simple.component';
import { SupportComponent } from './components/support/support.component';
import { RateplanTemplateSelectorComponent } from './dialog/rateplan-template-selector/rateplan-template-selector.component';
import { TemplateSelectorComponent } from '../products/manage/rateplan/template-selector/template-selector.component';

const COMPONENTS: any[] = [
  BarChartComponent,
  BannerTestComponent,
  ChargeLoyaltyRulesComponent,
  ChargePrepaidRulesComponent,
  ClickOutsideDirective,
  CreditCardSimpleComponent,
  OfflineCardSimpleComponent,
  DialogAccountSettingsComponent,
  DialogCustomerAddressbookComponent,
  DialogCustomerPaymentsComponent,
  DialogCustomerShippingMethodComponent,
  DialogLinkRateplanChargeComponent,
  DialogLinkSubscriptionComponent,
  DialogManageFiltersComponent,
  DialogNewChargeComponent,
  FormChargeCutOffRulesComponent,
  FormChargeDetailsComponent,
  FormChargePriceComponent,
  FormChargeScheduleComponent,
  FormChargeRulesComponent,
  GridComponent,
  HorizontalBarChartComponent,
  HeaderComponent,
  LineChartComponent,
  NavSideComponent,
  PanelAccountComponent,
  PanelFiltersComponent,
  PanelFrequencyComponent,
  PanelGridSearchComponent,
  DialogShortcutsComponent,
  PanelPreferencesComponent,
  PanelProductPriceComponent,
  SystemMessageComponent,
  ExportNotificationComponent,
  GlobalHeaderComponent,
  GlobalHeaderImplComponent,
  NavbarComponent,
  StatusChipComponent,
  UsageBasedRulesComponent,
  SupportComponent,
  RateplanTemplateSelectorComponent,
  TemplateSelectorComponent,

  RestrictionDirective,
  RestrictionPipe,
  DialogSyncActivePlansComponent
]

const MODULES: any[] = [
  AppMaterialModule,
  AppSharedModule,
  CommonModule,
  FormsModule,
  MainRoutingModule,
  NgxCleaveDirectiveModule,
  ReactiveFormsModule,
  NgxEchartsModule.forRoot({
    echarts: () => import('echarts'),
  }),
  RebNgxMatMenuModule,
  RebNgxMatMenuItemModule,
  RebNgxMatMenuButtonItemModule,
  RebNgxMatButtonModule,
  RebNgxMatTabsModule,
  RebNgxMatTabItemModule,
  RebNgxNavbarModule,
  RebNgxChipModule,
  RebNgxMatButtonIconModule,
  RebNgxAvatarModule,
  RebNgxMatMenuIconModule,
  RebNgxLabelModule,
  RebNgxDividerModule,
  RebNgxHeadingLabelModule,
  RebNgxIconModule

]

const PROVIDERS: any[] = [
  MainService,
  DatePipe,
  // RestrictionDirective
]

@NgModule({
  declarations: [COMPONENTS],
  exports: [COMPONENTS],
  imports: [MODULES],
  providers: [ PROVIDERS ]
})

export class SharedModule {
  constructor() {
    console.log('shared.module.ts was loaded.');
  }
}
